import React, { useState, useEffect} from 'react';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import '../../styles/TimeSheetPage.css';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Navbar from '../../pages/Navbar';
import api from "../../api";
import { fetchUserId, fetchCompanyId } from '../../helpers/CompanyId';

const steps = [
  'Download Excel Template',
  'Upload Attendance Sheet',
  'Review and Calculate Pay',
];

const formatMonthToMMYYYY = (month) => {
  const [shortMonth, year] = month.split(' ');
  const date = new Date(`${shortMonth} 1, ${year}`);
  const monthNum = String(date.getMonth() + 1).padStart(2, '0'); 
  return `${monthNum}-${year}`;
};

// Function to convert Excel date serial number to "MMM YYYY" format (e.g., "Feb 2024")
const convertExcelDate = (serial) => {
  const excelDate = new Date(Math.round((serial - 25569) * 86400 * 1000));
  const options = { year: 'numeric', month: 'short' };
  return excelDate.toLocaleDateString('en-US', options);
};

// Function to validate noOfDays based on the month
const isValidDays = (month, noOfDays) => {
  const monthDays = {
    January: 31,
    February: 28, // Leap year check will be handled on the backend
    March: 31,
    April: 30,
    May: 31,
    June: 30,
    July: 31,
    August: 31,
    September: 30,
    October: 31,
    November: 30,
    December: 31,
  };

  // Check if month is valid
  if (!(month in monthDays)) {
    return false;
  }

  // Check for leap year in February
  const currentYear = new Date().getFullYear();
  if (month === 'February') {
    if ((currentYear % 4 === 0 && currentYear % 100 !== 0) || (currentYear % 400 === 0)) {
      monthDays['February'] = 29; // Leap year
    }
  }

  // Ensure noOfDays is treated as a number
  return Number(noOfDays) === monthDays[month];
};


const TimeSheetPage = () => {
  const [downloadedFileName, setDownloadedFileName] = useState('');
  const [buploadedFileName, setBUploadedFileName] = useState('');
  const [uploadedFileName, setUploadedFileName] = useState(''); // Store the uploaded file name
  const [uploadedFileName1, setUploadedFileName1] = useState('');
  const [activeStep, setActiveStep] = useState(0);
  const [successMessage, setSuccessMessage] = useState('');
  const [paysuccessMessage, setPaySuccessMessage] = useState('');

  const [timeSheetData, setTimeSheetData] = useState([]);
  const [EarningsData, setEarningsData] = useState([]);

  const [errorMessages, setErrorMessages] = useState([]);
  const [payerrorMessages, setPayErrorMessages] = useState([]);

  const [showMissingOptions, setShowMissingOptions] = useState(false);
  const [missingEmployees, setMissingEmployees] = useState([]);
  const [showExtraOptions, setShowExtraOptions] = useState(false); // New state for extra employees
  const [extraEmployees, setExtraEmployees] = useState([]); // New state for extra employees
  const navigate = useNavigate(); // useNavigate for navigation
  const [error, setError] = useState(null);
  const [Attendance, setAttendance] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [calculatedData, setCalculatedData] = useState([]);
  const [payrollSettings, setPayrollSettings] = useState(null);
  const [dynamicHeaders, setDynamicHeaders] = useState([]);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const downloadAttdTemplate = () => {
    // Logic to download Attendance template
    const worksheet = XLSX.utils.json_to_sheet([]);
    const headers = ['SNO','Emp ID', 'Name', 'Month', 'No. of Days', 'Attendance', 'LOP Days', 'OT'];
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TimeSheet');
    const fileName = 'attendance_template.xlsx';
  XLSX.writeFile(workbook, fileName);
  
  // Set the downloaded file name state
  setDownloadedFileName(fileName); // Call setDownloadedFileName to utilize it
  };

  const downloadTemplate = () => {
    // Logic to download Attendance template
    const worksheet = XLSX.utils.json_to_sheet([]);
    const headers = ['SNO','Emp ID', 'Name', 'Month', 'Bonus', 'Allowance', 'Deductions'];
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TimeSheet');
    const fileName = 'bonus_template.xlsx';
  XLSX.writeFile(workbook, fileName);
  
  // Set the downloaded file name state
  setDownloadedFileName(fileName); // Call setDownloadedFileName to utilize it
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFileName(file.name); // Store the uploaded file name

      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        const processedData = data.slice(1).map((row) => ({
          sno: row[0],
          empId: row[1],
          name: row[2],
          month: convertExcelDate(row[3]),
          noOfDays: row[4],
          attendance: row[5],
          lopDays: row[6],
          OT: row[7],
          // allowance: row[8],
          // deductions: row[9],
        }));

        setTimeSheetData(processedData);
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleFileUpload1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFileName1(file.name); // Store the uploaded file name

      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        const earprocessedData = data.slice(1).map((row) => ({
          sno: row[0],
          empId: row[1],
          name: row[2],
          month: convertExcelDate(row[3]),
          bonus: row[4],
          allowance: row[5],
          deductions: row[6],
        }));

        setEarningsData(earprocessedData);
      };

      reader.readAsBinaryString(file);
    }
  };

  const fetchTimesheets = async () => {

    const userId = await fetchUserId();
    if (!userId) {
      setError('User ID not found');
      return;
    }
 
    const companyId = await fetchCompanyId(userId);
    if (!companyId) {
      setError('Company ID not found');
      return;
    }

    const month = localStorage.getItem('month'); // Retrieve the month from local storage

    console.log('Fetching timesheets for company ID:', companyId, 'and month:', month);

    try {
      const attendanceResponse = await api.get(`/api/timesheet/${companyId}/${month}/`);
      console.log('Fetched Attendance:', attendanceResponse.data.combined_data);
      setAttendance(attendanceResponse.data.combined_data); 
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Error fetching timesheet and attendance data.');
    }
  };

    const fetchCompensationSettings = async () => {
      try {

        const userId = await fetchUserId();
        if (!userId) {
          setError('User ID not found');
          return;
        }
    
        const companyId = await fetchCompanyId(userId);
        if (!companyId) {
          setError('Company ID not found');
          return;
        }

        if (!companyId) {
          console.error('Company ID not found');
          return;
        }
        const response = await api.get(`/api/payroll-settings/${companyId}/`);

        console.log('Fetched Payroll Settings:', response.data); // Debug: Check if data is fetched
        setPayrollSettings(response.data); // Store the fetched settings
      } catch (error) {
        console.error('Error fetching payroll settings:', error);
      }
    };

    useEffect(() => {
      fetchCompensationSettings();
    }, []);

const fetchEmployeeData = async () => {

  const userId = await fetchUserId();
  if (!userId) {
    setError('User ID not found');
    return;
  }
 
  const companyId = await fetchCompanyId(userId);
  if (!companyId) {
    setError('Company ID not found');
    return;
  }

  console.log("CID:", companyId);

  try {
      const response = await api.get(`/api/employee/work-details/`, {
          params: { company_id: companyId }, // Query parameters
          headers: {
              'Content-Type': 'application/json', // Optional, based on API requirements
          },
      });

      // Axios automatically resolves the response; if status is not 2xx, it will throw an error.
      console.log('API Response:', response.data); // Log the entire response for debugging

      // Ensure the response contains the 'custom_work_details' key
      if (response.data && Array.isArray(response.data.custom_work_details)) {
          setEmployeeData(response.data.custom_work_details);
          return response.data.custom_work_details;
      } else {
          console.error('Invalid response format:', response.data);
          return []; // Return an empty array if the structure is not as expected
      }
  } catch (error) {
      console.error('Error fetching employee data:', error.message || error);
      return []; // Return an empty array on error
  }
};


  // Effect to fetch timesheets again when entering Step 3
  useEffect(() => {
    if (activeStep === 2) {
      fetchTimesheets();
      fetchEmployeeData();
      fetchCompensationSettings();
    }
  }, [activeStep]);

  const calculateEEPF = (basic, payrollSettings, employmentType) => {
    let eePF = 0;
    if (
      payrollSettings.pf &&
      payrollSettings.pfEmploymentType.includes(employmentType)
    ) {
      if (payrollSettings.pf_type === "15k") {
        eePF = Math.round(basic > 15000 ? 15000 * 0.12 : basic * 0.12);
      } else {
        eePF = Math.round(basic * 0.12);
      }
    }
    return eePF;
  };

  const calculatePT = async (totalPay, location, gender = null) => {
    const response = await api.get(`/api/pt-rules/${location}/`);
    const ptRules = response.data[location];
  
    // Filter rules based on income slabs and gender if applicable
    const applicableRule = ptRules.find(rule => {
      const withinSlab = 
        totalPay >= parseFloat(rule.income_slab_min) && 
        (rule.income_slab_max === "0.00" || totalPay <= parseFloat(rule.income_slab_max));
      const genderMatch = 
        rule.gender === "both" ||  
        rule.gender === null ||  
        gender === null ||        
        rule.gender === gender;    
      return withinSlab && genderMatch;
    });
    
    return applicableRule ? parseFloat(applicableRule.tax_amount) : 0;
  };

  const calculateLWF = async (location) => {
    try {
        // Fetch LWF data for the specified location
        const response = await api.get(`/api/lwf-rules/${location}/`);
        const { frequency, employee_deduction, calendar } = response.data;

        // Determine the financial year based on the calendar
        const currentDate = new Date();
        let financialYearStart, financialYearEnd;

        if (calendar === "April-March") {
            financialYearStart = new Date(currentDate.getFullYear(), 3, 1); // April 1
            financialYearEnd = new Date(currentDate.getFullYear() + 1, 2, 31); // March 31
        } else if (calendar === "January-December") {
            financialYearStart = new Date(currentDate.getFullYear(), 0, 1); // Jan 1
            financialYearEnd = new Date(currentDate.getFullYear(), 11, 31); // Dec 31
        } else if (calendar === "July-June") {
            financialYearStart = new Date(currentDate.getFullYear(), 6, 1); // July 1
            financialYearEnd = new Date(currentDate.getFullYear() + 1, 5, 30); // June 30
        } else if (calendar === "October-September") {
            financialYearStart = new Date(currentDate.getFullYear(), 9, 1); // Oct 1
            financialYearEnd = new Date(currentDate.getFullYear() + 1, 8, 30); // Sept 30
        } else {
            throw new Error("Unsupported calendar format");
        }

        
        const currentMonth = currentDate.getMonth() + 1; 
        const isEligible = (() => {
            if (frequency === "Monthly") {
                return true; 
            } else if (frequency === "Half-yearly") {
                return [4, 10].includes(currentMonth); 
            } else if (frequency === "Yearly") {
                return currentMonth === 4; 
            }
            return false;
        })();
        return isEligible ? parseFloat(employee_deduction) : 0;
    } catch (error) {
        console.error("Error calculating LWF deduction:", error);
        return 0; 
    }
  };

  
  useEffect(() => {
    const fetchAndCalculateData = async () => {
      if (Attendance.length > 0 && employeeData.length > 0 && payrollSettings) {
      const result = await Promise.all( 
        Attendance.map(async (attendanceEntry) => {
        const empId = attendanceEntry.empId;
        const employee = employeeData.find((emp) => emp.empId === empId);
  
        if (!employee) return null;
  
        const { CTCpayAMT, DLoansAMT } = employee.salary_details[0];
        const { attendance, no_of_days, OT } = attendanceEntry;
        const earnings = attendanceEntry.earnings[0];
        const employmentType = employee.employmentType; // Retrieve employmentType

        // Access personal details
        const personalDetails = employee.personal_details[0] || {};
        const { gender, location } = personalDetails;

        // Extract allowance and deductions from the nested earnings object
        const allowance = earnings?.allowance || 0;
        const deductions = earnings?.deductions || 0;
        const bonus = earnings?.bonus || 0;
  
        // Basic Calculation
        const basicPercentage = payrollSettings.basic_percentage / 100;
        const daPercentage = payrollSettings.da_percentage / 100;
        const hraPercentage = payrollSettings.hra_percentage / 100;
  
        let basic, da, hra, grossPay, specialAllowance;

        // Reimbursement Calculation
        const reimbursements = employee.salary_details[0].reimbursements || {};
        let reimbursementTotal = 0;
        const reimbursementDetails = [];

        for (const [name, value] of Object.entries(reimbursements)) {
            const reimbursementValue = parseFloat(value);
            reimbursementTotal += reimbursementValue;
            reimbursementDetails.push({ name, amount: reimbursementValue });
        }

        if (payrollSettings.da_enabled && !payrollSettings.hra_enabled) {
          // DA enabled, HRA disabled
          const E_Basic = Math.round(CTCpayAMT * basicPercentage);
          const E_DA = Math.round(CTCpayAMT * daPercentage);
          basic = Math.round((E_Basic * attendance) / no_of_days);
          da = Math.round((E_DA * attendance) / no_of_days);
          grossPay = basic + da;
          specialAllowance = grossPay - basic - da - reimbursementTotal;
        } else if (payrollSettings.da_enabled && payrollSettings.hra_enabled) {
          // Both DA and HRA enabled
          const E_Basic = Math.round(CTCpayAMT * basicPercentage);
          const E_DA = Math.round(E_Basic * daPercentage);
          const E_HRA = Math.round(E_Basic * hraPercentage);
          basic = Math.round((E_Basic * attendance) / no_of_days);
          hra = Math.round((E_HRA * attendance) / no_of_days);
          da = Math.round((E_DA * attendance) / no_of_days);
          grossPay = basic + hra + da;
          specialAllowance = grossPay - basic - hra - da - reimbursementTotal;
        } else if(!payrollSettings.da_enabled && payrollSettings.hra_enabled) {
          const E_Basic = Math.round(CTCpayAMT * basicPercentage);
          // const E_DA = Math.round(E_Basic * daPercentage);
          const E_HRA = Math.round(E_Basic * hraPercentage);
          // const E_Reambesments = reimbursementTotal;
          const E_SA = CTCpayAMT - (E_Basic + E_HRA + reimbursementTotal);
          basic = Math.round((E_Basic * attendance) / no_of_days);
          hra = Math.round((E_HRA * attendance) / no_of_days);
          // da = Math.round((E_DA * attendance) / no_of_days);
          specialAllowance = Math.round((E_SA * attendance) / no_of_days);
          grossPay = basic + hra + specialAllowance;
          da = 0;
          // specialAllowance = grossPay - basic - hra - reimbursementTotal;
        } else {
          // Default case if neither DA nor HRA is enabled
          basic = Math.round((CTCpayAMT * basicPercentage * attendance) / no_of_days);
          da = 0;
          hra = 0;
          grossPay = basic;
          specialAllowance = grossPay - basic - reimbursementTotal;
        }
  
        // OT Calculation
        const otPay = Math.round((CTCpayAMT * OT) / no_of_days);
        const totalPay = grossPay + otPay + allowance;

        // Updated PF Calculation using the new function
        const eePF = calculateEEPF(basic, payrollSettings, employmentType);
  
        // ESI and PT Calculation
        // const esi = payrollSettings.esi ? Math.round((totalPay - eePF) * 0.0075) : 0;
        const esi = (payrollSettings.esi && 
          payrollSettings.esiEmploymentType.includes(employmentType))        ? Math.round((totalPay - eePF) * 0.0075) 
        : 0;
        // PT Calculation (dynamic fetch based on location and totalPay)
        let pt = 0; 
        if (payrollSettings.professional_tax && 
          payrollSettings.ptEmploymentType.includes(employmentType) &&
          payrollSettings.ptLocations.includes(location)) {
          if (location === "Maharashtra" && gender) {
            // Include gender for Maharashtra
            pt = await calculatePT(totalPay, location, gender); 
          } else {
            // For other locations, gender is not required
            pt = await calculatePT(totalPay, location); 
          }
        }

        // LWF Calculation (dynamic fetch based on location and calendar)
        let lwf = 0;
        if (payrollSettings.lwf && 
          payrollSettings.lwfEmploymentType.includes(employmentType) &&
          payrollSettings.lwfLocations.includes(location)) {
          // Fetch and calculate LWF deduction dynamically
          lwf = await calculateLWF(location);
        }

        // Final Net Pay Calculation
        const netPay = (totalPay + bonus) - Number(eePF) - Number(esi) - Number(pt) - Number(lwf) - Number(DLoansAMT) - Number(deductions);
        const totalDeductions = Number(eePF) + Number(pt) + Number(DLoansAMT) + Number(deductions) + Number(lwf) + Number(esi);

        return {
          ...attendanceEntry,
          salary: CTCpayAMT,
          basic,
          hra: hra || 0, // Ensure HRA is 0 if not applicable
          da: da || 0, // Ensure DA is 0 if not applicable
          special_allowance: specialAllowance,
          grossPay,
          otPay,
          allowance,
          bonus,
          totalPay,
          eePF: Number(eePF).toFixed(2),
          esi: Number(esi).toFixed(2),
          pt: Number(pt),
          lwf: Number(lwf),
          deductiblesLoans: Number(DLoansAMT),
          deductions: Number(deductions),
          net_pay: netPay.toFixed(2),
          totalDeductions: totalDeductions.toFixed(2),
        };

      })
    );
  
      setCalculatedData(result.filter(Boolean)); // Filter out any null entries
    }
  };
  fetchAndCalculateData();
  }, [Attendance, employeeData, payrollSettings]);
  

  useEffect(() => { 
    fetchEmployeeData();
  }, []);

  const handleSubmit = async ({ isEarnings = false }) => {
    setErrorMessages([]);
    setSuccessMessage('');
  
    const uploadedName = isEarnings ? uploadedFileName1 : uploadedFileName;
    const dataToUpload = isEarnings ? EarningsData : timeSheetData;
  
    if (uploadedName !== downloadedFileName) {
      alert('The uploaded file name must be the same as the downloaded file name.');
      return;
    }
  
    const employeeData = await fetchEmployeeData();
    const userId = await fetchUserId();
    if (!userId) {
      setError('User ID not found');
      return;
    }
  
    const companyId = await fetchCompanyId(userId);
    if (!companyId) {
      setError('Company ID not found');
      return;
    }
  
    if (!Array.isArray(employeeData)) {
      console.error('Expected employeeData to be an array but got:', employeeData);
      return;
    }
  
    const employeeMap = new Map(
      employeeData.map((emp) => [
        emp.empId,
        `${emp.firstName} ${emp.lastName}`.trim(),
      ])
    );
  
    const dataEmployeeIds = dataToUpload.map((entry) => String(entry.empId));
    const employeeSet = new Set(employeeData.map((emp) => emp.empId));
    const dataEmployeeSet = new Set(dataEmployeeIds);
  
    const missingEmployees = [...employeeSet].filter((empId) => !dataEmployeeSet.has(empId));
    const extraEmployees = [...dataEmployeeSet].filter((empId) => !employeeSet.has(empId));
  
    if (missingEmployees.length > 0 || extraEmployees.length > 0) {
      if (missingEmployees.length > 0) {
        setMissingEmployees(missingEmployees);
        setShowMissingOptions(true);
      }
  
      if (extraEmployees.length > 0) {
        setExtraEmployees(extraEmployees);
        setShowExtraOptions(true);
      }
  
      return;
    }
  
    const invalidEntries = dataToUpload.map((entry) => {
      const isEmpNameValid = employeeMap.get(String(entry.empId)) === entry.name;
  
      if (isEarnings) {
        return { entry, isEmpNameValid };
      } else {
        const monthName = entry.month.split(' ')[0];
        const fullMonthName = new Date(`${monthName} 1`).toLocaleString('default', { month: 'long' });
        const daysWorked = Number(entry.noOfDays);
        const attendance = Number(entry.attendance);
        const lopDays = Number(entry.lopDays);
  
        return {
          entry,
          isDaysValid: isValidDays(fullMonthName, daysWorked),
          isAttendanceValid: attendance <= daysWorked,
          isAttendanceLopValid: attendance + lopDays === daysWorked,
          isEmpIdValid: employeeSet.has(String(entry.empId)),
          isEmpNameValid,
        };
      }
    }).filter((validation) =>
      isEarnings
        ? !validation.isEmpNameValid
        : !validation.isDaysValid ||
          !validation.isAttendanceValid ||
          !validation.isAttendanceLopValid ||
          !validation.isEmpIdValid ||
          !validation.isEmpNameValid
    );
  
    if (invalidEntries.length > 0) {
      const messages = invalidEntries.map(({ entry, ...validations }) => {
        let message = `${entry.name}: `;
        if (!isEarnings) {
          const monthName = entry.month.split(' ')[0];
          const fullMonthName = new Date(`${monthName} 1`).toLocaleString('default', { month: 'long' });
          const daysWorked = Number(entry.noOfDays);
          const attendance = Number(entry.attendance);
          const lopDays = Number(entry.lopDays);
  
          if (!validations.isDaysValid) {
            message += `${daysWorked} is not a valid number of days in ${fullMonthName}. `;
          }
          if (!validations.isAttendanceValid) {
            message += `Attendance (${attendance}) exceeds the number of days (${daysWorked}). `;
          }
          if (!validations.isAttendanceLopValid) {
            message += `Attendance (${attendance}) + LOP Days (${lopDays}) should equal the number of days (${daysWorked}). `;
          }
          if (!validations.isEmpIdValid) {
            message += `EmpId (${entry.empId}) for ${entry.name} is not valid. `;
          }
        }
  
        if (!validations.isEmpNameValid) {
          message += `EmpName mismatch for empId ${entry.empId}: expected '${employeeMap.get(String(entry.empId))}', got '${entry.name}'. `;
        }
  
        return message;
      });
  
      setErrorMessages(messages);
      return;
    }
  
    const updatedData = dataToUpload.map((entry) => {
      const formattedMonth = formatMonthToMMYYYY(entry.month);
      return {
        ...entry,
        month: formattedMonth,
        company: companyId,
      };
    });
  
    if (updatedData.length > 0) {
      localStorage.setItem('month', updatedData[0].month);
    }
  
    try {
      const endpoint = isEarnings ? '/api/earnings/upload/' : '/api/timesheet/upload/';
      const response = await api.post(endpoint, updatedData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (response.status === 200) {
        setSuccessMessage('Data uploaded successfully!');
      } else {
        setErrorMessages([response.data.message || 'Error uploading data.']);
      }
    } catch (error) {
      console.error('Error uploading data:', error);
      setErrorMessages(['There was an error in submitting your data.']);
    }
  };

  const handleYesMissing = () => {
    navigate('/employeelist'); // Navigate if the user chooses to delete missing employees
  };

  const handleNoMissing = () => {
    setShowMissingOptions(false); // Hide the Yes/No options for missing employees
  };

  const handleYesExtra = () => {
    navigate('/employeesetup');
  };

  const handleNoExtra = () => {
    setShowExtraOptions(false); 
  };

  // const savePayData = async () => {
  //   try {

  //     for (const entry of calculatedData) {
       
  //       const response = await api.post('/api/save-pay-data/', entry, {
  //         headers: {
  //           'Content-Type': 'application/json', // Ensure content type is JSON
  //         },
  //       });
    
  //       console.log('Data saved successfully:', response.data);
  //     }
  //     setSuccessMessage('Pay data saved successfully!');
  //   } catch (error) {
  //     console.error('Error saving pay data:', error);
  //     setErrorMessages(['Error saving pay data. Please try again.']);
  //   }
  // };
  

  const savePayData = async () => {
    try {
      for (const entry of calculatedData) {
        const response = await api.post('/api/save-pay-data/', entry, {
          headers: { 'Content-Type': 'application/json' },
        });
        console.log('Data saved successfully:', response.data);
      }
      setPaySuccessMessage('Pay data saved successfully!');
      setPayErrorMessages([]); // Clear previous errors if any
    } catch (error) {
      console.error('Error saving pay data:', error);
      setPayErrorMessages(['Error saving pay data. Please try again.']);
      setPaySuccessMessage(''); // Clear success message if error occurs
    }
  };
  

  return (
    <div>
     <Navbar />
      <div className="timesheet-container">
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {activeStep === 0 && (
          <div className="step-content">
            <h2>Step 1: Download Attendance Excel Template</h2>
            
            <div className="button-group">
              <Button onClick={downloadAttdTemplate} variant="contained">Download Attendance Template</Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                sx={{ mt: 2 }}  
              >
                Next
              </Button>
            </div>

            <h2>Step 2: Download Allowances and Deductions Excel Template</h2>
            
            <div className="button-group">
              <Button onClick={downloadTemplate} variant="contained">Download Template</Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                sx={{ mt: 2 }}  
              >
                Next
              </Button>
            </div>

          </div>
        )}
        {activeStep === 1 && (
          <div className="step-content">
            <h2>Step 1: Upload Attendance Sheet</h2>
            <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} className="upload-button" />
            {timeSheetData.length > 0 && (
              <>
                <h2>Time Sheet Data</h2>
                <table>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Emp ID</th>
                      <th>Name</th>
                      <th>Month</th>
                      <th>No. of Days</th>
                      <th>Attendance</th>
                      <th>LOP Days</th>
                      <th>OT</th>
                      {/* <th>Allowance</th>
                      <th>Deductions</th> */}
                      </tr>
                </thead>
                <tbody>
                  {timeSheetData.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.sno}</td>
                      <td>{entry.empId}</td>
                      <td>{entry.name}</td>
                      <td>{entry.month}</td>
                      <td>{entry.noOfDays}</td>
                      <td>{entry.attendance}</td>
                      <td>{entry.lopDays}</td>
                      <td>{entry.OT}</td>
                      {/* <td>{entry.allowance}</td>
                      <td>{entry.deductions}</td> */}
                    </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

            {/* Button Group for Back and Submit */}
            <div className="button-group-two">
              <Button onClick={handleBack} variant="contained" sx={{ mr: 1 }}>
                Back
              </Button>
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                color="primary"
                onClick={() => handleSubmit({ isEarnings: false })} // For Timesheet data

                // onClick={handleSubmit}
              >
                Submit
              </Button>

              <Button 
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                Next
              </Button>
            </div>

            <h2>Step 2: Upload Earnings Sheet</h2>
            <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload1} className="upload-button" />
            {EarningsData.length > 0 && (
              <>
                <h2>Earnings and Deductions</h2>
                <table>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Emp ID</th>
                      <th>Name</th>
                      <th>Month</th>
                      <th>Bonus</th>
                      <th>Allowance</th>
                      <th>Deductions</th>

                      </tr>
                </thead>
                <tbody>
                  {EarningsData.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.sno}</td>
                      <td>{entry.empId}</td>
                      <td>{entry.name}</td>
                      <td>{entry.month}</td>
                      <td>{entry.bonus}</td>
                      <td>{entry.allowance}</td>
                      <td>{entry.deductions}</td>
                    </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

            {/* Button Group for Back and Submit */}
            <div className="button-group-two">
              <Button onClick={handleBack} variant="contained" sx={{ mr: 1 }}>
                Back
              </Button>
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                color="primary"
                onClick={() => handleSubmit({ isEarnings: true })}
                // onClick={handleSubmit1}
              >
                Submit
              </Button>
              
              <Button 
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                Next
              </Button>
            </div>

          <div>
  {/* Error message block */}
  {errorMessages.length > 0 && (
    <div className="error-messages" style={{ color: 'red' }}>
      {errorMessages.map((message, index) => (
        <p key={index}>{message}</p>
      ))}
    </div>
  )}

  {/* Success message block */}
  {successMessage && (
    <div className="success-message" style={{ color: 'green' }}>
      <p>{successMessage}</p>
    </div>
  )}

  {/* Your form or other components */}
</div>

           
          </div>
        )}

        {activeStep === 2 && (
          <div className="step-content">
            <h2>Step 3: Review and Calculate Pay</h2>
            
            <div className="timesheet-table">
              <h2>Timesheet Data</h2>
              <table>
                <thead>
                  <tr>
                    <th>SNO</th>
                    <th>Emp ID</th>
                    <th>Name</th>
                    <th>Month</th>
                    <th>No. of Days</th>
                    <th>Attendance</th>
                    <th>OT</th>
                    <th>LOP Days</th>
                    <th>Salary</th>
                    <th>Basic</th>
                    <th>DA</th>
                    <th>HRA</th>
                    <th>Special Allowance</th>
                    <th>Gross Pay</th>
                    <th>OT Pay</th>
                    <th>Allowance</th>
                    <th>Bonus</th>
                    <th>Total Pay</th>
                    <th>EE PF</th>
                    <th>ESI</th>
                    <th>PT</th>
                    <th>LWF</th>
                    <th>Deductibles & Loans</th>
                    <th>This month Deductions</th>
                    <th>Total Deductions</th>
                    <th>Net Pay</th>
                  </tr>
                </thead>
                  <tbody>
                    {calculatedData.map((entry, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{entry.empId}</td>
                        <td>{entry.name}</td>
                        <td>{entry.month}</td>
                        <td>{entry.no_of_days}</td>
                        <td>{entry.attendance}</td>
                        <td>{entry.OT}</td>
                        <td>{entry.lop_days}</td>
                        <td>{entry.salary}</td>
                        <td>{entry.basic}</td>
                        <td>{entry.da}</td>
                        <td>{entry.hra}</td>
                        <td>{entry.special_allowance}</td>
                        <td>{entry.grossPay}</td>
                        <td>{entry.otPay}</td>
                        <td>{entry.allowance}</td>
                        <td>{entry.bonus}</td>
                        <td>{entry.totalPay}</td>
                        <td>{entry.eePF}</td>
                        <td>{entry.esi}</td>
                        <td>{entry.pt}</td>
                        <td>{entry.lwf}</td>
                        <td>{entry.deductiblesLoans}</td>
                        <td>{entry.deductions}</td>
                        <td>{entry.totalDeductions}</td>
                        <td>{entry.net_pay}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="button-group-two">
              <Button onClick={handleBack} variant="contained" sx={{ mr: 2 }}>
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={savePayData} // Make sure to handle the submission of this data appropriately
              >
                Submit
              </Button>
            </div>
            {paysuccessMessage && <p style={{ color: 'green' }}>{paysuccessMessage}</p>}
            {payerrorMessages.length > 0 && <p style={{ color: 'red' }}>{payerrorMessages[0]}</p>}

          </div>
        )}


        {/* Missing Employees Options */}
        {showMissingOptions && (
          <div className="modal">
            <h3>Missing Employees Found</h3>
            <p>Do you want to remove the missing employees from the employee data?</p>
            <button onClick={handleYesMissing}>Yes</button>
            <button onClick={handleNoMissing}>No</button>
            <div>
              <h4>Missing Employees:</h4>
              <ul>
                {missingEmployees.map((empId, index) => (
                  <li key={index}>{empId}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Extra Employees Options */}
        {showExtraOptions && (
          <div className="modal">
            <h3>New Employees Found</h3>
            <p>Do you want to add the new employees to the employee data?</p>
            <button onClick={handleYesExtra}>Yes</button>
            <button onClick={handleNoExtra}>No</button>
            <div>
              <h4>New Employees:</h4>
              <ul>
                {extraEmployees.map((empId, index) => (
                  <li key={index}>{empId}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeSheetPage;
